// extracted by mini-css-extract-plugin
module.exports =  {"anchorList":"anchorList___y6SF4","accordion":"accordion___VX7w3","wrapper":"wrapper___VKx5P"};